import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Steps from './components/Steps';
import Gallery from './components/Gallery';
import Languages from './components/Languages';
import CTA from './components/CTA';
import Privacy from './components/Privacy';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Steps />
        <Gallery />
        <Languages />
        <CTA />
        <Privacy />
      </main>
      <Footer />
    </>
  );
}
